import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { useEffect, useState } from "react";
import { getVacancies } from "../actions/ApiCalls";
import {IMAGE_URL} from "../path";
import DOMPurify from 'dompurify';
import './Careers.css';
import { useNavigate } from "react-router-dom";

function Careers() {
    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
    };

    const navigate = useNavigate();
    const [vacancies, setVacancies] = useState<any[]>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const imgUrl = IMAGE_URL;

    const createSlug = (text: string) => {
        return text
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '') // remove special characters
            .replace(/\s+/g, '-')         // replace spaces with dashes
            .replace(/-+/g, '-')          // collapse multiple dashes
            .trim();
    };

    useEffect(() => {
        getVacancies()
            .then(response => setVacancies(response.data))
            .catch(error => console.error("Failed to fetch vacancies:", error));

        document.title = "Vinimark | Careers";
    }, []);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Truncate HTML and replace <p> tags with styled <p>
    const truncateHtmlContent = (html: string, maxLength: number) => {
        const cleanHtml = html.replace(/\s+/g, ' ').trim();

        // Strip tags for character counting
        const textOnly = cleanHtml.replace(/<[^>]*>/g, '');

        if (textOnly.length <= maxLength) return cleanHtml.replace(/<p>/g, '<p style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0">');

        // Find where to truncate in the original HTML based on text-only length
        let count = 0;
        let truncated = '';
        const regex = /(<[^>]+>|[^<]+)/g; // Match tags or text
        let match;

        while ((match = regex.exec(cleanHtml)) !== null) {
            const part = match[0];
            if (part.startsWith('<')) {
                // HTML tag, include it
                truncated += part;
            } else {
                // Text, count characters
                if (count + part.length > maxLength) {
                    truncated += part.slice(0, maxLength - count);
                    break;
                } else {
                    truncated += part;
                    count += part.length;
                }
            }
        }

        // Close any unclosed tags
        const tagStack: string[] = [];
        const tagRegex = /<\/?([a-z]+)[^>]*>/gi;
        let tagMatch;
        while ((tagMatch = tagRegex.exec(truncated)) !== null) {
            const [full, tag] = tagMatch;
            if (full.startsWith('</')) {
                const lastTag = tagStack[tagStack.length - 1];
                if (lastTag === tag) tagStack.pop();
            } else if (!full.endsWith('/>')) {
                tagStack.push(tag);
            }
        }
        for (let i = tagStack.length - 1; i >= 0; i--) {
            truncated += `</${tagStack[i]}>`;
        }

        // Replace all <p> tags with styled <p>
        truncated = truncated.replace(/<p>/g, '<p style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0">');

        return truncated + '...';
    };



    const isMobile = windowWidth <= 575;

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
        }}>
            <Header />

            {/* Intro Section */}
            <div style={{ maxWidth: '100%', padding: '0 20px', boxSizing: 'border-box' }}>
                <div style={{ marginTop: '130px', display: "flex", flexDirection: isMobile ? 'column' : 'row' }}>
                    <div style={{ flex: 1 }}></div>
                    <div style={{
                        flex: 1,
                        textAlign: 'left',
                        boxSizing: 'border-box',
                        marginLeft: window.innerWidth > 575 ? '46px' : '0'
                    }}>
                        <p style={{ fontWeight: 600 }}>CAREERS</p>
                        <p style={{ width: isMobile ? '90%' : '60%', fontWeight: 400 }}>
                            At Vinimark, we’re privileged to stand at the forefront of the South African wine industry. Our people make this position possible: we’re a collective of passionate experts and enthusiasts working toward a sustainable and innovative future for the country’s viticulture legacy.
                        </p>
                        <p style={{ width: isMobile ? '90%' : '60%', fontWeight: 400 }}>
                            Whether it’s collaborating on new brands, planting trees at our warehouses, or connecting over a shared love of wine, we approach our work with a pioneering spirit, creativity, and care. If this sounds like your kind of team, we’d love to hear from you. Explore our current openings or get in touch at the link below.
                        </p>
                        <p style={{ fontSize: '13px', lineHeight: '16.9px', marginBottom: '100px' }}>
                            <a style={linkStyle} href="/subscribe">Join our mailing list</a>
                        </p>
                    </div>
                </div>
            </div>

            {/* Vacancies List */}
            {vacancies.map((vacancy, index) => (
                <div
                    key={index}
                    style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'flex-start',
                        marginBottom: '25px',
                    }}
                >
                    <div style={{
                        width: isMobile ? '100%' : '50%',
                        flexShrink: 0,
                        paddingRight: isMobile ? '0' : '0px',
                    }}>
                        <img
                            style={{ width: '100%' }}
                            src={imgUrl + vacancy.image_path}
                            alt={vacancy.title}
                        />
                    </div>

                    <div style={{
                        flex: 1,
                        textAlign: 'left',
                        paddingLeft: isMobile ? '24px' : '26px',
                        paddingTop: isMobile ? '24px' : '0',
                    }}>
                        <div style={{
                            flex: 1,
                            textAlign: 'left',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            width: isMobile ? '90%' : '60%',
                        }}>
                            <p style={{
                                fontSize: '13px',
                                lineHeight: '16.9px',
                                fontWeight: 600,
                                marginTop: 0,
                                textTransform: 'uppercase',
                                marginBottom: '10px',
                            }}>
                                {vacancy.title}
                            </p>
                            <p style={{ fontSize: '10px', fontWeight: 600, marginBottom: '10px' }}>{vacancy.year_posted}</p>
                            <div
                                style={{
                                    marginBottom: '10px',
                                    fontWeight: 400,
                                    width: '90%',

                                }}
                                // className='career-p'
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(truncateHtmlContent(vacancy.content, 300)),
                                }}
                            />
                            <a
                                style={linkStyle}
                                onClick={() => {
                                    navigate(`/vacancies/${createSlug(vacancy.title)}`, {
                                        state: { career: vacancy },
                                    });
                                }}
                            >
                                Read more
                            </a>
                        </div>
                    </div>
                </div>
            ))}

            {/* Newsletter CTA */}
            <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                <a
                    style={{
                        ...linkStyle,
                        display: 'block',
                        width: '90%',
                        textAlign: 'center',
                        padding: '30px'
                    }}
                    href={'/subscribe'}
                >
                    Join our newsletter
                </a>
            </div>

            <Footer />
        </div>
    );
}

export default Careers;
